import React from "react";
import { TableUi } from "../../ui/TableUi";
import { useDispatch } from "react-redux";
import {
  moduloSetActive,
  moduloStartDelete,
  rutasModuloSetActive,
} from "../../../actions/usuario";
import { showDeleteConfirm } from "../../../helpers/confirmModal";
import { Space, Tooltip } from "antd";
import { ButtonUi } from "../../ui/ButtonUi";
import { TipoButtonConstants } from "../../../types/typesConstants";
import { TagStatusUi } from "../../ui/TagStatusUi";
import { MenuUnfoldOutlined } from "@ant-design/icons";
const columns = (acciones) => [
  {
    title: "N°",
    dataIndex: "index",
    key: "index",
    render: (text, record, index) => <>{index + 1}</>,
  },
  {
    title: "Nombres",
    dataIndex: "nombre",
    key: "nombre",
  },
  {
    title: "¿Está activo?",
    dataIndex: "state",
    key: "state",
    render: (text) => <TagStatusUi status={text} />,
  },
  {
    title: "Acciones",
    dataIndex: "acciones",
    key: "acciones",
    render: (text, record) => (
      <Space size="middle">
        <ButtonUi
          typeUi={TipoButtonConstants.EditarTable}
          onClick={() => acciones.handleEditar(record)}
          displayText={false}
        ></ButtonUi>
        <ButtonUi
          typeUi={TipoButtonConstants.EliminarTable}
          onClick={() => acciones.handleEliminar(record)}
          displayText={false}
        />
        <Tooltip title="Mantenimiento de Rutas">
          <ButtonUi
            typeUi={TipoButtonConstants.CustomButton}
            icon={<MenuUnfoldOutlined />}
            onClick={() => acciones.handleMenuRutas(record)}
            displayText={false}
            color="cyan"
            variant="solid"
          />
        </Tooltip>
      </Space>
    ),
  },
];
export const ModuloTable = ({
  modulos,
  handleOpenModal,
  handleOpenRutaForm,
}) => {
  const dispatch = useDispatch();
  const handleEditar = (modulo) => {
    dispatch(moduloSetActive(modulo));
    handleOpenModal();
  };
  const handleMenuRutas = (modulo) => {
    dispatch(moduloSetActive(modulo));
    dispatch(rutasModuloSetActive(modulo?.rutasmodulo));
    handleOpenRutaForm();
  };
  const handleEliminar = (modulo) => {
    showDeleteConfirm(
      "¿Está seguro de eliminar el módulo seleccionado?",
      modulo.nombre,
      (isConfirmed) => {
        if (isConfirmed) {
          dispatch(moduloStartDelete(modulo));
        }
      }
    );
  };
  return (
    <TableUi
      data={modulos}
      columns={columns({ handleEditar, handleEliminar, handleMenuRutas })}
      size="small"
      rowKey="id"
    />
  );
};
